import request from "../request";

export default {
  //消息-列表
  getMyMessage(data) {
    return request.get("/message/unread", data);
  },

  //消息-阅读
  readMessage(data) {
    return request.post("/message/readMessage", data);
  },

  //消息-一键已读
  readAll(data) {
    return request.post("/message/readAll", data);
  },

  //消息-删除
  delete(data) {
    return request.post("/message/delete", data);
  },

  //手机验证码
  sendSMSCode(data) {
    return request.post("/message/sendSMSCode", data);
  }
};
